import { Star } from 'react-feather'
import styled from 'styled-components'

import { _S_Medium, mainColors, semanticColors } from '../../styles'

export const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${_S_Medium};
  padding: 2px 6px;
  gap: 4px;
  border-radius: 30px;
  background: ${mainColors.neutralLight};
  color: ${mainColors.black};
`

export const StarIcon = styled(Star)`
  display: flex;
  color: ${semanticColors.warningMedium};
  fill: ${semanticColors.warningMedium};
  width: 16px;
  height: 16px;
`
